export default "__VITE_ASSET__de2caa14__"